export function getConfig(p = {}) {

    const {config = {}} = p;

    const commonConfig = config.common || {};
    const globalsConfig = config.globals || {};

    const {WAPP, DEV} = globalsConfig;

    const common = {
        ...commonConfig,
        siteName: "Configurator - Studio Arkitekter",
        description: "Configurator for Studio Arkitekter projects",
        graphql: {
            route: (DEV) ? "/graphql" : "/g" + WAPP
        }
    };

    return {
        config: {
            ...config,
            common: common
        },
    }
}
